import React from 'react';
import { Link } from 'react-router-dom';
import { Languages, LogOut } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Desktop language switcher + auth buttons (login / signup / logout / admin).
 * Hidden on mobile — mobile has its own drawer.
 */
const NavbarUserActions = ({ t, language, toggleLanguage, user, logout }) => (
  <div className="hidden md:flex items-center space-x-4">
    <button
      data-testid="navbar-language-switcher"
      onClick={toggleLanguage}
      className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors px-3 py-2 rounded-lg hover:bg-white/10"
      aria-label="Toggle language"
    >
      <Languages size={18} />
      <span className="text-sm font-medium uppercase">{language}</span>
    </button>

    {user && user.id ? (
      <div className="flex items-center space-x-3">
        {user.role === 'admin' && (
          <Button asChild variant="ghost" size="sm" className="text-cyan-400 hover:text-cyan-300 hover:bg-white/10">
            <Link to="/admin" data-testid="navbar-admin">Admin</Link>
          </Button>
        )}
        <span className="text-white/70 text-sm">{user.name || user.email}</span>
        <Button
          data-testid="navbar-logout"
          onClick={logout}
          variant="ghost"
          className="text-white/90 hover:text-white hover:bg-white/10"
          size="sm"
        >
          <LogOut size={16} className="mr-1" />
          {language === 'el' ? 'Αποσύνδεση' : 'Logout'}
        </Button>
      </div>
    ) : (
      <>
        <Button asChild variant="ghost" className="text-white/90 hover:text-white hover:bg-white/10">
          <Link to="/login" data-testid="navbar-login">{t.nav.login}</Link>
        </Button>
        <Button asChild className="bg-white text-black hover:bg-white/90">
          <Link to="/register" data-testid="navbar-signup">{t.nav.signup}</Link>
        </Button>
      </>
    )}
  </div>
);

export default NavbarUserActions;
